import React, { Suspense } from "react";
import Loading from "../Loading/Loading";

const SuspenseFallback = ({ children }) => {
    return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default SuspenseFallback;
